(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.hasAttribute('data-sort-select')) return;
    const form = select.closest('form');
    if (form) form.requestSubmit();
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const opener = target.closest('[data-sort-open]');
    if (opener) {
      const sheet = document.getElementById(opener.getAttribute('aria-controls'));
      if (sheet && typeof sheet.showModal === 'function' && !sheet.open) sheet.showModal();
      return;
    }

    if (target.closest('[data-sort-close]')) {
      const sheet = target.closest('dialog');
      if (sheet) sheet.close();
      return;
    }

    if (target instanceof HTMLDialogElement && target.hasAttribute('data-sort-sheet')) target.close();
  });

  window.matchMedia('(min-width: 750px)').addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('[data-sort-sheet][open]').forEach((sheet) => sheet.close());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const query = window.matchMedia('(min-width: 750px)');

    const sync = () => {
      document.querySelectorAll('.footer__column').forEach((column) => {
        column.open = query.matches;
      });
    };

    document.addEventListener('click', (event) => {
      if (!query.matches || !(event.target instanceof Element)) return;
      if (event.target.closest('.footer__heading')) event.preventDefault();
    });

    query.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const opener = target.closest('[data-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-dialog-open'));
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
      return;
    }

    if (target.closest('[data-dialog-close]')) {
      const dialog = target.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    if (target instanceof HTMLDialogElement && target.hasAttribute('data-light-dismiss')) {
      target.close();
    }
  });

  window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
    if (!event.matches) return;
    const drawer = document.getElementById('menu-drawer');
    if (drawer && drawer.open) drawer.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const update = (track) => {
      const root = track.closest('[data-showcase]');
      if (!root) return;

      const max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('showcase--static', max <= 1);

      const prev = root.querySelector('[data-showcase-arrow="prev"]');
      const next = root.querySelector('[data-showcase-arrow="next"]');
      if (prev) prev.setAttribute('aria-disabled', String(track.scrollLeft <= 1));
      if (next) next.setAttribute('aria-disabled', String(track.scrollLeft >= max - 1));
    };

    const updateAll = () => {
      document.querySelectorAll('[data-showcase-track]').forEach(update);
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const button = target.closest('[data-showcase-arrow]');
      if (!button || button.getAttribute('aria-disabled') === 'true') return;

      const root = button.closest('[data-showcase]');
      const track = root && root.querySelector('[data-showcase-track]');
      if (!track) return;

      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const direction = button.getAttribute('data-showcase-arrow') === 'next' ? 1 : -1;
      track.scrollBy({
        left: direction * (track.clientWidth + gap),
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    });

    document.addEventListener(
      'scroll',
      (event) => {
        const target = event.target;
        if (target instanceof Element && target.hasAttribute('data-showcase-track')) update(target);
      },
      { capture: true, passive: true }
    );

    window.addEventListener('resize', updateAll);
    window.addEventListener('load', updateAll);
    document.addEventListener('shopify:section:load', updateAll);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAll);
    } else {
      updateAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const behavior = () => (reduceMotion.matches ? 'auto' : 'smooth');

    const getData = (root) => {
      if (!root._productData) {
        const el = root.querySelector('[data-product-json]');
        try {
          root._productData = el ? JSON.parse(el.textContent) : { variants: [] };
        } catch (error) {
          root._productData = { variants: [] };
        }
      }
      return root._productData;
    };

    const clampQuantity = (root) => {
      const input = root.querySelector('[data-quantity-input]');
      if (!input) return;
      const max = input.hasAttribute('max') ? Number(input.getAttribute('max')) : Infinity;
      let value = parseInt(input.value, 10);
      if (!Number.isFinite(value) || value < 1) value = 1;
      if (value > max) value = Math.max(1, max);
      input.value = String(value);
    };

    const applyVariant = (root, variant) => {
      const available = Boolean(variant && variant.available);

      root.querySelectorAll('[data-add-to-cart]').forEach((button) => {
        button.disabled = !available;
        button.textContent = available ? root.dataset.labelAdd : root.dataset.labelSoldOut;
      });

      if (!variant) return;

      const idInput = root.querySelector('[data-variant-id]');
      if (idInput) idInput.value = String(variant.id);

      root.querySelectorAll('[data-price-current]').forEach((el) => {
        el.textContent = variant.price;
      });
      root.querySelectorAll('[data-price-compare]').forEach((el) => {
        el.hidden = !variant.compare;
        if (variant.compare) el.textContent = variant.compare;
      });

      const quantityInput = root.querySelector('[data-quantity-input]');
      if (quantityInput) {
        if (variant.max !== null && variant.max !== undefined) {
          quantityInput.setAttribute('max', String(variant.max));
        } else {
          quantityInput.removeAttribute('max');
        }
        clampQuantity(root);
      }

      const stock = root.querySelector('[data-low-stock-message]');
      if (stock) {
        const threshold = Number(root.dataset.lowStockThreshold) || 0;
        const show =
          threshold > 0 && available && variant.quantity !== null && variant.quantity > 0 && variant.quantity <= threshold;
        stock.hidden = !show;
        stock.textContent = show ? root.dataset.lowStock.replace('__COUNT__', String(variant.quantity)) : '';
      }

      if (window.history && window.history.replaceState && root.dataset.productUrl) {
        window.history.replaceState(null, '', root.dataset.productUrl + '?variant=' + variant.id);
      }

      if (variant.media) {
        const item = root.querySelector('[data-media-id="' + variant.media + '"]');
        const list = root.querySelector('[data-gallery-list]');
        if (item && list) {
          if (list.scrollWidth > list.clientWidth + 1) {
            list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: behavior() });
          } else {
            item.scrollIntoView({ behavior: behavior(), block: 'nearest' });
          }
        }
      }
    };

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('product__option-input')) return;
      const root = input.closest('[data-product]');
      if (!root) return;

      const selected = Array.from(root.querySelectorAll('.product__option')).map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      const variant = getData(root).variants.find((candidate) =>
        candidate.options.every((option, index) => option === selected[index])
      );
      applyVariant(root, variant);
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const minus = target.closest('[data-quantity-minus]');
      const plus = target.closest('[data-quantity-plus]');
      if (!minus && !plus) return;

      const root = target.closest('[data-product]');
      const input = root && root.querySelector('[data-quantity-input]');
      if (!input) return;

      const current = parseInt(input.value, 10) || 1;
      input.value = String(current + (plus ? 1 : -1));
      clampQuantity(root);
    });

    document.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.hasAttribute('data-quantity-input')) {
        const root = event.target.closest('[data-product]');
        if (root) clampQuantity(root);
      }
    });

    document.addEventListener(
      'scroll',
      (event) => {
        const list = event.target;
        if (!(list instanceof Element) || !list.hasAttribute('data-gallery-list')) return;
        const counter = list.closest('[data-gallery]').querySelector('[data-gallery-current]');
        if (!counter || !list.clientWidth) return;
        counter.textContent = String(Math.round(list.scrollLeft / list.clientWidth) + 1);
      },
      { capture: true, passive: true }
    );

    const syncGalleryFocus = () => {
      document.querySelectorAll('[data-gallery-list]').forEach((list) => {
        if (list.scrollWidth > list.clientWidth + 1) {
          list.setAttribute('tabindex', '0');
        } else {
          list.removeAttribute('tabindex');
        }
      });
    };

    const initSticky = (root) => {
      const bar = root.querySelector('[data-sticky]');
      const target = root.querySelector('.product__submit');
      if (!bar || !target || !('IntersectionObserver' in window)) return;

      let pastButton = false;
      let footerInView = false;
      const update = () => bar.classList.toggle('is-visible', pastButton && !footerInView);

      new IntersectionObserver(([entry]) => {
        pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      }).observe(target);

      const footerVisible = new Set();
      const footerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            footerVisible.add(entry.target);
          } else {
            footerVisible.delete(entry.target);
          }
        });
        footerInView = footerVisible.size > 0;
        update();
      });
      document.querySelectorAll('.shopify-section-group-footer-group').forEach((el) => footerObserver.observe(el));
    };

    const init = () => {
      document.querySelectorAll('[data-product]').forEach((root) => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        initSticky(root);
      });
      syncGalleryFocus();
    };

    window.addEventListener('resize', syncGalleryFocus);
    window.addEventListener('load', syncGalleryFocus);
    document.addEventListener('shopify:section:load', init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
